import { format } from "date-fns";
import Mousetrap from "mousetrap";
import { useEffect, useState } from "react";
import {
  DataGrid,
  Icon,
  IconButton,
  ListStatusVencimento,
  PermissionDialog,
  SelecaoTitulosFiltro,
  Tooltip,
} from "../../../components";
import {
  filtrosUrl,
  PermisoesHelper,
  selecaoTitulosLote,
  value,
} from "../../../helpers";
import { ListLayout } from "../../../layouts";
import {
  BancosCaixasService,
  ColaboradorService,
  CondicoesPagamentoService,
  ContasPagarService,
  history,
  MeioPagamentoService,
  notification,
  PessoaService,
  SessionService,
  UsuarioService,
} from "../../../services";
import { formatDate, formatPrice, responseErros } from "../../../utils";
import {
  BaixaLotePagar,
  ButtonMenu,
  FiltroCustom,
  FormFiltroAvancado,
  RenegociacaoTitulos,
} from "./components";
import { calculaTotalAPagar } from "./listContaPagar";
import { useImportContext } from "../../../contexts/import.context";
import { HistoricoPagamentos } from "../addContaPagar/components";
import { addIdUsuario, getAtrasoDias } from "../addContaPagar/add-conta-pagar";
import { usePermissaoRetirarBaixa } from "../../../components/permission-dialog/use-permissao-retirar-baixa";

const ListContasPagar = () => {
  const { initialCollapses } = useImportContext();

  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("contas-pagar-visualizar");
  const [loading, setLoading] = useState(false);
  const [contasPagar, setContasPagar] = useState([]);
  const [baixaLote, setBaixaLote] = useState({});
  const [totalAPagar, setTotalAPagar] = useState({
    multa: 0,
    juros: 0,
    subtotal: 0,
    pagar: 0,
  });
  const [rowCount, setRowCount] = useState(null);
  const [listaPessoas, setListaPessoas] = useState([]);
  const [listaPessoasFiltro, setListaPessoasFiltro] = useState([]);
  const [pessoaFiltro, setPessoaFiltro] = useState(null);
  const [buscaFiltro, setBuscaFiltro] = useState("");
  const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
  const [contasPagarSelecionadas, setContasPagarSelecionadas] = useState([]);
  const [ultimaBusca, setUltimaBusca] = useState({
    tipo: "simples",
    filtros: {},
  });
  const [contasFiltroSelecionadas, setContasFiltroSelecionadas] =
    useState(null);
  const [renderBaixaLote, setRenderBaixaLote] = useState(false);
  const [renderRenegociacaoTitulos, setRenderRenegociacaoTitulos] =
    useState(false);
  const [renegociacaoTitulos, setRenegociacaoTitulos] = useState({});
  const [listaCondicoesPagamento, setListaCondicoesPagamento] = useState([]);
  const [listaBancosCaixas, setListaBancosCaixas] = useState([]);
  const [listaMeiosPagamento, setListaMeiosPagamento] = useState([]);
  const [openHistorico, setOpenHistorico] = useState(false);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const { dialogPermissao, confirmarExclusaoRenegociacao } =
    usePermissaoRetirarBaixa();

  const sessionService = new SessionService();
  const usuario = sessionService.getUsuario();
  // const [parametrosFiscais, setParametrosFiscais] = useState({});
  const status = [
    {
      nome: "ABERTO",
      label: "Aberto",
      cor: "#4FBB53",
    },
    {
      nome: "BAIXADO",
      label: "Baixado",
      cor: "#004780",
    },
    {
      nome: "BAIXADO_PARCIAL",
      label: "Baixado Parcial",
      cor: "#EA9D2B",
    },
    {
      nome: "CANCELADO",
      label: "Cancelado",
      cor: "#DC3545",
    },
    {
      nome: "RENEGOCIADO",
      label: "Renegociado",
      cor: "#70309F",
    },
  ];
  const buttonSelectOpcoes = [
    { permission: true, descricao: "Importação Excel" },
  ];
  const colunas = [
    {
      field: "status",
      headerName: "Status",
      flex: 110,
      renderCell: (params) => {
        switch (params.value) {
          case "BAIXADO":
            return (
              <Tooltip title="Baixado" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#004780", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
          case "BAIXADO_PARCIAL":
            return (
              <Tooltip title="Baixado Parcial" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#EA9D2B", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
          case "CANCELADO":
            return (
              <Tooltip title="Cancelado" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#DC3545", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
          case "RENEGOCIADO":
            return (
              <Tooltip title="Renegociado" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#70309F", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
          default:
            return (
              <Tooltip title="Aberto" arrow placement="right">
                <Icon>
                  <i
                    className="ph-fill ph-circle"
                    style={{ color: "#4FBB53", fontSize: 18 }}
                  ></i>
                </Icon>
              </Tooltip>
            );
        }
      },
    },
    {
      field: "numeroTitulo",
      headerName: "Nº Título",
      flex: 230,
      filtrar: true,
    },
    {
      field: "empresaId",
      headerName: "Empresa",
      flex: 150,
      renderCell: (params) => {
        if (!usuario.acessosEmpresas?.length) return "";
        const empresa = value.autoComplete(
          usuario.acessosEmpresas,
          params.value,
        )?.fantasia;
        return (
          <Tooltip title={empresa} arrow placement="right">
            <span>{empresa.replace(/\s+/g, "").slice(0, 3).toUpperCase()}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "tipo",
      headerName: "Tipo",
      flex: 200,
      valueGetter: (params) =>
        params.value == "TITULO_NORMAL" ? "Título normal" : "Nota de débito",
    },
    {
      field: "pessoaId",
      headerName: "Fornecedor",
      flex: 600,
      sortable: false,
      filtroPessoa: true,
      valueGetter: (params) =>
        listaPessoas.find((item) => item.id == params.value)?.nomeRazaoSocial,
    },
    {
      field: "valor",
      headerName: "Valor",
      flex: 220,
      sortable: false,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "saldoPagar",
      headerName: "Saldo a Pagar",
      flex: 250,
      sortable: false,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) =>
        params.value > 0 ? formatPrice(params.value) : "R$ 0,00",
    },
    {
      field: "dataVencimento",
      headerName: "Vencimento",
      flex: 250,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) =>
        format(formatDate.received(params?.value), "dd/MM/yyyy"),
    },
    {
      field: "acoes",
      headerName: "Ações",
      sortable: false,
      flex: 200,
      align: "center",
      headerAlign: "center",
      disableClickEventBubbling: true,
      hideable: false,
      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={async (event) => {
                event.stopPropagation();
                const conta = contasPagar.find((item) => item.id === params.id);
                const listaIdUsuario = [];
                addIdUsuario(conta.pagamentos, listaIdUsuario);
                const usuarios = await buscaUsuarios(listaIdUsuario);
                setContaSelecionada({
                  ...conta,
                  pagamentos: conta.pagamentos.map((pagamento) => ({
                    ...pagamento,
                    insertUserName: usuarios.find(
                      ({ id }) => pagamento.insertUserId === id,
                    )?.nome,
                  })),
                });
                setOpenHistorico(true);
              }}
            >
              <Tooltip title="Histórico de Pagamentos" arrow placement="top">
                <i className="ph-bold ph-invoice" style={{ fontSize: 18 }}></i>
              </Tooltip>
            </IconButton>
            {permissoesHelper.temPermisao("contas-pagar-editar") && (
              <IconButton
                onClick={() => {
                  initialCollapses();
                  onClickEditContaPagar(params.id);
                }}
              >
                <Tooltip title="Editar" arrow placement="top">
                  <i className="ph-fill ph-pencil" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
            {permissoesHelper.temPermisao("contas-pagar-excluir") && (
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  onClickDeleteContaPagar(params.id);
                }}
              >
                <Tooltip title="Excluir" arrow placement="top">
                  <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
          </div>
        );
      },
    },
  ];

  const dadosPagamentoColunas = [
    {
      field: "dataPagamento",
      headerName: "Data",
      flex: 400,
      valueGetter: (params) => {
        return format(formatDate.received(params.value), "dd/MM/yyyy");
      },
    },
    {
      field: "horaPagamento",
      headerName: "Hora",
      flex: 250,
      valueGetter: (params) => {
        return format(formatDate.received(params.row.dataPagamento), "HH:mm");
      },
    },
    {
      field: "bancoCaixaId",
      headerName: "Banco/Caixa",
      flex: 400,
      valueGetter: (params) => {
        const conta = listaBancosCaixas.find((item) => item.id == params.value);
        if (!conta) return params.value;
        return conta.nome;
      },
    },
    {
      field: "atrasoDias",
      headerName: "Atraso",
      flex: 350,
      valueGetter: (params) => {
        const dataPagamento = params.row.dataPagamento;
        return getAtrasoDias(contaSelecionada?.dataVencimento, dataPagamento);
      },
    },
    {
      field: "meioPagamentoId",
      headerName: "Meio Pagamento",
      flex: 600,
      valueGetter: (params) => {
        const meioPagamento = listaMeiosPagamento.find(
          (meio) => meio.id == params.value,
        );
        if (!meioPagamento) return params.value;
        return meioPagamento.descricao;
      },
    },
    {
      field: "tipoBaixa",
      headerName: "Tipo de Baixa",
      flex: 600,
      renderCell: (params) => {
        switch (params.value) {
          case "BAIXA_RENEGOCIACAO":
            return "Baixa por Renegociação";
          default:
            return "Baixa Normal";
        }
      },
    },
    {
      field: "valor",
      headerName: "Valor Baixa",
      flex: 450,
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "insertUserName",
      headerName: "Usuário",
      flex: 450,
    },
  ];

  const contasPagarService = new ContasPagarService();
  const bancosCaixasService = new BancosCaixasService();
  const meioPagamentoService = new MeioPagamentoService();
  const condicoesPagamentoService = new CondicoesPagamentoService();
  const pessoaService = new PessoaService();
  const colaboradorService = new ColaboradorService();
  const usuarioService = new UsuarioService();

  useEffect(() => {
    const filtros = filtrosUrl.get();
    if (filtros.status) {
      const status = filtros.status.split(",");
      handlePesquisaAvancada({ ...filtros, status });
    } else {
      buscaContasPagar(filtros);
    }
    buscarMeiosPagamento();
    buscarCondicoesPagamento();
  }, []);

  const atalhosListPagar = [
    {
      keys: ["esc"],
      action: async (e) => {
        e.preventDefault();
        sairBaixaLoteRenegociacao();
        return false;
      },
    },
  ];

  atalhosListPagar.map(({ keys, action }) => Mousetrap.bind(keys, action));

  Mousetrap.stopCallback = function () {
    return false;
  };

  useEffect(() => {
    limparSelecao();
  }, [renderBaixaLote, renderRenegociacaoTitulos]);

  function sairBaixaLoteRenegociacao() {
    setRenderBaixaLote(false);
    setRenderRenegociacaoTitulos(false);
    retornoTopo();
    setBaixaLote({});
  }

  const retornoTopo = () => {
    const ref = document.getElementById("topo-contas-pagar");
    setTimeout(
      () =>
        ref?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        }),
      100,
    );
  };

  async function buscarPessoaVendedor(filtros) {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      vendedor: true,
    };
    const dadosUsuario = sessionService.getUsuario();
    const result = await colaboradorService.getAll(filtro);
    if (!result.isAxiosError) {
      const colaboradorVendedorUsuario = result.data.find(
        (colaborador) => colaborador.usuarioId === dadosUsuario.id,
      );
      const permissaoCaixaColaborador = await permissoesHelper.temPermisao(
        "utilizar-caixa-colaborador",
      );
      if (colaboradorVendedorUsuario && permissaoCaixaColaborador) {
        buscarBancosCaixas(colaboradorVendedorUsuario?.bancoCaixaId);
      } else {
        buscarBancosCaixas();
      }
    } else {
      responseErros(result);
    }
  }

  const buscaContasPagar = async function (filter = {}) {
    setLoading(true);
    const result = await contasPagarService.getAll(filter);
    if (!result.isAxiosError) {
      setContasPagar(result.data.rows);
      setUltimaBusca({ tipo: "simples", filtros: filter });
      await buscarRelacionamentosContaPagar(result.data.rows);
      setRowCount(result.data.count);
      buscarPessoaVendedor();
      // buscarJurosMulta();
      filtrosUrl.set(filter);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  // const buscarJurosMulta = () => {
  //   configuracoesService.get().then((result) => {
  //     if (!result.isAxiosError) {
  //       const data = result.data.rows[0];
  //       const parametrosFiscaisTemp = {
  //         jurosPorcentagem: data?.jurosPorcentagem
  //           ? data.jurosPorcentagem / 100
  //           : null,
  //         multaPorcentagem: data?.multaPorcentagem
  //           ? data.multaPorcentagem / 100
  //           : null,
  //         carencia: data?.carencia ?? 0,
  //       };
  //       setParametrosFiscais(parametrosFiscaisTemp);
  //       setBaixaLote((prevState) => ({
  //         ...prevState,
  //         ...parametrosFiscaisTemp,
  //       }));
  //       setRenegociacaoTitulos((prevState) => ({
  //         ...prevState,
  //         ...parametrosFiscaisTemp,
  //       }));
  //     }
  //   });
  // };

  const buscarRelacionamentosContaPagar = async (listaContasPagar) => {
    const idsMeiosPagamento = [];
    const idsPessoas = [];
    for (const objeto of listaContasPagar) {
      idsMeiosPagamento.push(objeto.meioPagamentoId);
      idsPessoas.push(objeto.pessoaId);
    }
    const idsUnicosPessoas = [...new Set(idsPessoas)].filter(
      (item) => item !== null,
    );
    await buscarPessoas({}, idsUnicosPessoas);
  };

  const buscarBancosCaixas = async function (id) {
    const filtros = {
      nonPaginated: true,
      ativado: true,
    };
    if (id) filtros.id = id;
    const result = await bancosCaixasService.getAll(filtros);
    if (!result.isAxiosError) {
      setListaBancosCaixas(result.data);
    } else {
      responseErros(result);
    }
  };

  const buscarMeiosPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaMeiosPagamento(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarCondicoesPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    condicoesPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaCondicoesPagamento(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscaUsuarios = async (listaIdUsuario) => {
    if (listaIdUsuario.length) {
      const filtro = {
        nonPaginated: true,
        id: listaIdUsuario,
      };
      return usuarioService.getAll(filtro).then((result) => {
        if (!result.isAxiosError) {
          return result.data;
        } else {
          responseErros(result);
          return [];
        }
      });
    }
  };

  const buscarPessoas = async (filtros, listaIds) => {
    let filtro = {
      ativado: true,
      attributes: ["id", "nomeRazaoSocial", "updatedAt"],
    };
    if (listaIds?.length) {
      filtro = {
        ...filtro,
        id: listaIds,
        nonPaginated: true,
      };
    } else {
      filtro = { ...filtro, ...filtros, limite: 15 };
    }
    const result = await pessoaService.getAllFiltroAvancadoSimplificada(filtro);
    if (!result.isAxiosError) {
      const listaPessoas = result.data;
      if (listaIds?.length) {
        setListaPessoas((pessoasAnteriores) =>
          selecaoTitulosLote.unirPorId(pessoasAnteriores, listaPessoas),
        );
      } else setListaPessoasFiltro(listaPessoas?.rows);
    } else {
      responseErros(result);
    }
  };

  const selecionarContas = (listaContasPagar) => {
    const totais = calculaTotalAPagar(
      listaContasPagar,
      baixaLote.dataPagamento ?? new Date(),
      baixaLote,
    );
    setTotalAPagar(totais);
    setContasPagarSelecionadas(listaContasPagar);
    setLinhasSelecionadas(listaContasPagar.map((conta) => conta.id));
  };

  const limparSelecao = () => {
    selecionarContas([]);
    setContasFiltroSelecionadas(null);
  };

  const handleSelecaoContas = (newRowSelectionModel) => {
    const listaContasPagar = newRowSelectionModel
      .map(
        (rowId) =>
          contasPagar.find((row) => row.id === rowId) ??
          contasPagarSelecionadas.find((conta) => conta.id === rowId),
      )
      .filter(selecaoTitulosLote.podeSelecionar);
    selecionarContas(listaContasPagar);
  };

  const selecionarTodasContasFiltro = async () => {
    const filtros = selecaoTitulosLote.montaFiltroTitulosAbertos(ultimaBusca);
    if (!filtros) {
      return notification.alertaGenericos(
        "O filtro atual não possui títulos em aberto.",
      );
    }
    setLoading(true);
    const result = await contasPagarService.getAllFiltroAvancado(filtros);
    setLoading(false);
    if (result.isAxiosError) return responseErros(result);
    const { rows, count } = result.data;
    if (!rows.length) {
      return notification.alertaGenericos(
        "O filtro atual não possui títulos em aberto.",
      );
    }
    const listaContasPagar = selecaoTitulosLote.unirPorId(
      contasPagarSelecionadas,
      rows,
    );
    if (
      count > rows.length ||
      listaContasPagar.length > selecaoTitulosLote.limiteTitulos
    ) {
      return notification.alertaGenericos(
        selecaoTitulosLote.mensagemLimite(
          Math.max(count, listaContasPagar.length),
        ),
      );
    }
    buscarRelacionamentosContaPagar(rows);
    selecionarContas(listaContasPagar);
    setContasFiltroSelecionadas({
      chave: selecaoTitulosLote.chaveBusca(ultimaBusca),
      ids: rows.map((conta) => conta.id),
    });
  };

  const desmarcarContasFiltro = () => {
    const idsFiltro = new Set(contasFiltroSelecionadas?.ids);
    selecionarContas(
      contasPagarSelecionadas.filter((conta) => !idsFiltro.has(conta.id)),
    );
    setContasFiltroSelecionadas(null);
  };

  const todasContasFiltroSelecionadas =
    contasFiltroSelecionadas?.chave ===
      selecaoTitulosLote.chaveBusca(ultimaBusca) &&
    selecaoTitulosLote.contemTodas(
      contasFiltroSelecionadas.ids,
      linhasSelecionadas,
    );

  const onClickCadastrarContaPagar = function (descricao) {
    switch (descricao) {
      case "Importação Excel":
        history.push("/financeiro/importacao-contas-pagar");
        break;
      default:
        history.push("/financeiro/contas-pagar/create");
        break;
    }
  };

  const onClickEditContaPagar = function (id) {
    history.push(`/financeiro/contas-pagar/${id}`);
  };

  const deletarContaPagar = async function (id) {
    setLoading(true);
    const result = await contasPagarService.deletar(id);
    if (!result.isAxiosError) {
      buscaContasPagar();
      notification.deletadoSucesso();
    } else {
      setLoading(false);
      responseErros(result);
    }
  };

  const onClickDeleteContaPagar = async function (id) {
    const contaSelecionada = contasPagar.find((item) => item.id === id);
    if (contaSelecionada.origem === "RENEGOCIAÇÃO") {
      const confirmado = await confirmarExclusaoRenegociacao(
        contaSelecionada,
        contasPagarService,
      );
      if (confirmado) {
        await deletarContaPagar(id);
      }
      return;
    }
    if (contaSelecionada.origem === "MANUAL") {
      const retornoAlerta = await notification.confirmacao(
        "Excluir!",
        "Tem certeza que deseja excluir essa conta a pagar?",
      );
      if (retornoAlerta.isConfirmed) {
        if (contaSelecionada.status === "ABERTO") {
          await deletarContaPagar(id);
        } else
          notification.alertaGenericos(
            "Só é permitido excluir títulos que se encontram em aberto.",
          );
      }
    } else
      notification.erroCadastroApi(
        "Só é permitido excluir títulos que foram inseridos manualmente.",
      );
  };

  const handlePesquisaAvancada = async (filter) => {
    setLoading(true);
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    if (
      filtrosAvancadosTemp.dataLancamentoStart &&
      filtrosAvancadosTemp.dataLancamentoEnd
    ) {
      porIntervalo.push({
        coluna: "dataLancamento",
        de: filtrosAvancadosTemp.dataLancamentoStart,
        ate: filtrosAvancadosTemp.dataLancamentoEnd,
      });
    }
    if (
      filtrosAvancadosTemp.dataVencimentoStart &&
      filtrosAvancadosTemp.dataVencimentoEnd
    ) {
      porIntervalo.push({
        coluna: "dataVencimento",
        de: filtrosAvancadosTemp.dataVencimentoStart,
        ate: filtrosAvancadosTemp.dataVencimentoEnd,
      });
    }
    if (
      filtrosAvancadosTemp.dataPagamentoStart &&
      filtrosAvancadosTemp.dataPagamentoEnd
    ) {
      porIntervalo.push({
        coluna: "dataPagamento",
        de: filtrosAvancadosTemp.dataPagamentoStart,
        ate: filtrosAvancadosTemp.dataPagamentoEnd,
      });
    }
    delete filtrosAvancadosTemp.dataLancamentoStart;
    delete filtrosAvancadosTemp.dataLancamentoEnd;
    delete filtrosAvancadosTemp.dataVencimentoStart;
    delete filtrosAvancadosTemp.dataVencimentoEnd;
    delete filtrosAvancadosTemp.dataPagamentoStart;
    delete filtrosAvancadosTemp.dataPagamentoEnd;
    const filtrosBusca = {
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    };
    const result = await contasPagarService.getAllFiltroAvancado(filtrosBusca);
    if (!result.isAxiosError) {
      setContasPagar(result.data.rows);
      setRowCount(result.data.count);
      setUltimaBusca({ tipo: "avancada", filtros: filtrosBusca });
      buscarRelacionamentosContaPagar(result.data.rows);
      const filtrosUrlTemp = { ...filter };
      delete filtrosUrlTemp.situacaoVencimento;
      filtrosUrl.set(filtrosUrlTemp);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const filtrarListaPorPessoa = (value) => {
    if (value) {
      buscaContasPagar({ pessoaId: value.id });
      setBuscaFiltro("");
    } else {
      buscaContasPagar();
      setListaPessoasFiltro([]);
    }
  };

  const sendServerDatagrid = (props) => {
    const { filtros, tipoFiltro } = props;
    if (!filtros) {
      setPessoaFiltro(null);
      setBuscaFiltro("");
    } else if (pessoaFiltro) {
      filtros.pessoaId = pessoaFiltro.id;
    }
    if (tipoFiltro === "simples") {
      buscaContasPagar(filtros);
    } else {
      handlePesquisaAvancada(filtros);
    }
  };

  return (
    <>
      <div id="topo-contas-pagar"></div>
      <ListLayout
        title="Contas a Pagar"
        loading={loading}
        buttonSelectOpcoes={buttonSelectOpcoes}
        onClickCadastrar={onClickCadastrarContaPagar}
        permissaoButton={permissoesHelper.temPermisao("contas-pagar-cadastrar")}
        ButtonMenu={
          <ButtonMenu
            renderBaixaLote={renderBaixaLote}
            setRenderBaixaLote={setRenderBaixaLote}
            renderRenegociacaoTitulos={renderRenegociacaoTitulos}
            setRenderRenegociacaoTitulos={setRenderRenegociacaoTitulos}
          />
        }
      >
        <div
          style={{
            marginBottom:
              renderBaixaLote || renderRenegociacaoTitulos ? 150 : 0,
          }}
        >
          <DataGrid
            initialState={{
              columns: {
                columnVisibilityModel: {
                  empresaId: usuario.acessosEmpresas?.length > 1,
                },
              },
            }}
            checkboxSelection={renderBaixaLote || renderRenegociacaoTitulos}
            onRowSelectionModelChange={handleSelecaoContas}
            selectionModel={linhasSelecionadas}
            keepNonExistentRowsSelected={
              renderBaixaLote || renderRenegociacaoTitulos
            }
            isRowSelectable={(params) =>
              selecaoTitulosLote.podeSelecionar(params.row)
            }
            extraActions={
              (renderBaixaLote || renderRenegociacaoTitulos) && (
                <SelecaoTitulosFiltro
                  todasSelecionadas={todasContasFiltroSelecionadas}
                  onChangeTodas={(selecionar) =>
                    selecionar
                      ? selecionarTodasContasFiltro()
                      : desmarcarContasFiltro()
                  }
                  quantidadeSelecionada={contasPagarSelecionadas.length}
                  onLimparSelecao={limparSelecao}
                />
              )
            }
            rows={contasPagar}
            columns={colunas}
            visualizarShow={permissoesHelper.temPermisao(
              "contas-pagar-visualizar",
            )}
            paginationMode={"server"}
            rowCount={rowCount}
            sendServer={(props) => sendServerDatagrid(props)}
            FormFiltroAvancado={FormFiltroAvancado}
            disableAcoes
            disableRowSelectionOnClick
            onClickEdit={onClickEditContaPagar}
            enableRowDoubleClick
            listaStatus={status}
            ListStatusCustom={ListStatusVencimento}
            FiltroCustom={
              <FiltroCustom
                buscaFiltro={buscaFiltro}
                setBuscaFiltro={setBuscaFiltro}
                listaPessoasFiltro={listaPessoasFiltro}
                setListaPessoasFiltro={setListaPessoasFiltro}
                pessoaFiltro={pessoaFiltro}
                setPessoaFiltro={setPessoaFiltro}
                buscarPessoas={buscarPessoas}
                filtrarListaPorPessoa={filtrarListaPorPessoa}
                sendServer={sendServerDatagrid}
                columns={colunas}
              />
            }
          />
        </div>
      </ListLayout>
      <BaixaLotePagar
        renderBaixaLote={renderBaixaLote}
        setRenderBaixaLote={setRenderBaixaLote}
        listaContasPagar={contasPagarSelecionadas}
        setListaContasPagar={setContasPagarSelecionadas}
        buscaContasPagar={buscaContasPagar}
        listaMeiosPagamento={listaMeiosPagamento}
        listaBancosCaixas={listaBancosCaixas}
        baixaLote={baixaLote}
        setBaixaLote={setBaixaLote}
        totalAPagar={totalAPagar}
        setTotalAPagar={setTotalAPagar}
      />
      <RenegociacaoTitulos
        renderRenegociacaoTitulos={renderRenegociacaoTitulos}
        setRenderRenegociacaoTitulos={setRenderRenegociacaoTitulos}
        renegociacaoTitulos={renegociacaoTitulos}
        setRenegociacaoTitulos={setRenegociacaoTitulos}
        calculaTotalAPagar={calculaTotalAPagar}
        buscaContasPagar={buscaContasPagar}
        listaCondicoesPagamento={listaCondicoesPagamento}
        listaContasPagar={contasPagarSelecionadas}
        setListaContasPagar={setContasPagarSelecionadas}
        listaPessoas={listaPessoas}
        totalAPagar={totalAPagar}
        retornoTopo={retornoTopo}
        setLoading={setLoading}
        setLinhasSelecionadas={setLinhasSelecionadas}
        setTotalAPagar={setTotalAPagar}
        listaMeiosPagamento={listaMeiosPagamento}
      />
      <HistoricoPagamentos
        dadosPagamentoList={contaSelecionada?.pagamentos ?? []}
        dadosPagamentoColunas={dadosPagamentoColunas}
        openHistorico={openHistorico}
        handleHistorico={() => setOpenHistorico(false)}
      />
      <PermissionDialog dialog={dialogPermissao} />
    </>
  );
};

export default ListContasPagar;
